import { graphql } from 'msw';
import {
  GetLookbookGalleryQuery,
  GetLookbookGalleryQueryVariables,
} from './getLookbookGallery';
import type { CurrentLook, ShopProductVariant } from './types';
import {
  GetLookbookPreviousLooksQuery,
  GetLookbookPreviousLooksQueryVariables,
} from './getPreviousLooks';
import {
  Look,
  VisionLookResemblanceSubmitInput,
  VisionOptInUpdateInput,
} from '../../../types/definitions/vendor/graphql-schema.d';
import {
  UpdateLookResemblanceAnswerMutation,
  UpdateLookResemblanceAnswerMutationVariables,
} from './updateLookResemblanceAnswer';
import {
  UpdateVisionOptInOutAnswerMutation,
  UpdateVisionOptInOutAnswerMutationVariables,
} from './updateVisionOptInOutAnswer';
import { OnboardingStatus } from '../../../utils/constants/OnboardingStatus';

const visionId = '1';
const currentLookBookId = '1';
const mockProductVariants: ShopProductVariant[] = [
  {
    __typename: 'ShopProductVariant',
    id: '3763342',
    sku: '3763342',
    url: 'https://www.stitchfix.com/product/Hawker-Rye-Essential-Wash-2-0-Slim-Fit-Pant/7XME4EG2P?sku-id=3582256&color=Navy&size=32&inseam=30&origin=anchoritem&source=anchored-fix&recommended-sku-id=3582256',
    image: {
      baseUrl: 'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
      mediaPath: '/v1744936345/qcclxhonr4xdinipyhab.jpg',
      altText: 'Mock Product',
      __typename: 'ShopMedia',
    },
    shopProduct: {
      name: 'Product 1',
    },
  },
  {
    __typename: 'ShopProductVariant',
    id: '3763339',
    sku: '3763339',
    url: 'https://www.stitchfix.com/product/Hawker-Rye-Essential-Wash-2-0-Slim-Fit-Pant/7XME4EG2P?sku-id=3582256&color=Navy&size=32&inseam=30&origin=anchoritem&source=anchored-fix&recommended-sku-id=3582256',
    image: {
      baseUrl: 'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
      mediaPath: '/v1744851798/jjusthegehgtp7drnuga.jpg',
      altText: 'Mock Product',
      __typename: 'ShopMedia',
    },
    shopProduct: {
      name: 'Product 2',
    },
  },
  {
    __typename: 'ShopProductVariant',
    id: '3387282',
    sku: '3387282',
    url: 'https://www.stitchfix.com/product/Hawker-Rye-Essential-Wash-2-0-Slim-Fit-Pant/7XME4EG2P?sku-id=3582256&color=Navy&size=32&inseam=30&origin=anchoritem&source=anchored-fix&recommended-sku-id=3582256',
    image: {
      baseUrl: 'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
      mediaPath: '/v1650323500/wcer2oe1xcjj8boqmc53.jpg',
      altText: 'Mock Product',
      __typename: 'ShopMedia',
    },
    shopProduct: {
      name: 'Product 3',
    },
  },
];

export const allMockLooks: CurrentLook[] = [
  {
    __typename: 'Look',
    id: 'look1',
    resemblesMeAnswer: true,
    image: {
      __typename: 'Image',
      baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
      mediaPath:
        '/v1749490826/visual_ai/mock-images/6223ea8d95804a3cfba6bf8304c89c721e6fe7f6_czlkta.png',
      altText: 'Mock Look 1',
    },
    shopProductVariants: mockProductVariants,
  },
  {
    __typename: 'Look',
    id: 'look2',
    resemblesMeAnswer: false,
    image: {
      __typename: 'Image',
      baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
      mediaPath:
        '/v1749490826/visual_ai/mock-images/73439412cbd8d8afeb6e9aadd02c08e112beb199_pddotx.png',
      altText: 'Mock Look 2',
    },
    shopProductVariants: mockProductVariants.slice(0, 1),
  },
  {
    __typename: 'Look',
    id: 'look3',
    resemblesMeAnswer: true,
    image: {
      __typename: 'Image',
      baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
      mediaPath:
        '/v1749490825/visual_ai/mock-images/938b068d6c2caf93722916edae3fa132d5831cc3_uigxvr.png',
      altText: 'Mock Look 3',
    },
    shopProductVariants: mockProductVariants.slice(0, 2),
  },
  {
    __typename: 'Look',
    id: 'look4',
    resemblesMeAnswer: true,
    image: {
      __typename: 'Image',
      baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
      mediaPath:
        '/v1749490825/visual_ai/mock-images/eb2b0bb8c363a6a3880cd084a01f4a1a1b0e56ab_khzhjm.png',
      altText: 'Mock Look 4',
    },
    shopProductVariants: mockProductVariants.slice(0, 2),
  },
  {
    __typename: 'Look',
    id: 'look5',
    resemblesMeAnswer: false,
    image: {
      __typename: 'Image',
      baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
      mediaPath:
        '/v1749490825/visual_ai/mock-images/885b6eec045bcfe4824b2079dd39309046e90755_mtdamx.png',
      altText: 'Mock Look 5',
    },
    shopProductVariants: mockProductVariants.slice(0, 2),
  },
  {
    __typename: 'Look',
    id: 'look6',
    resemblesMeAnswer: true,
    image: {
      __typename: 'Image',
      baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
      mediaPath:
        '/v1749490825/visual_ai/mock-images/6a554c79694961ebf103a8ebb23019435fc7d3bd_t2u6jo.png',
      altText: 'Mock Look 6',
    },
    shopProductVariants: mockProductVariants.slice(0, 2),
  },
  {
    __typename: 'Look',
    id: 'look7',
    resemblesMeAnswer: true,
    image: {
      __typename: 'Image',
      baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
      mediaPath:
        '/v1749490825/visual_ai/mock-images/2d99c39f5fb5bc5b63cebe1a3aa6df71b699f314_yqkdqj.png',
      altText: 'Mock Look 7',
    },
    shopProductVariants: mockProductVariants.slice(0, 2),
  },
  {
    __typename: 'Look',
    id: 'look8',
    resemblesMeAnswer: true,
    image: {
      __typename: 'Image',
      baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
      mediaPath:
        '/v1749490824/visual_ai/mock-images/2800ca64ad4c3ca1db3bdd39b765c76157e5f2e7_g3srly.png',
      altText: 'Mock Look 8',
    },
    shopProductVariants: mockProductVariants.slice(0, 2),
  },
];

export const defaultLookbook = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    vision: {
      __typename: 'Vision',
      id: visionId,
      onboardingStatus: OnboardingStatus.FULLY_ONBOARDED,
      isOptedInToRecurringLooks: true,
      currentLookBook: {
        id: currentLookBookId,
        __typename: 'LookBook',
        looks: allMockLooks.slice(0, 3),
      },
    },
  },
} satisfies GetLookbookGalleryQuery;

export const onboardedWithNoGalleries = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    vision: {
      __typename: 'Vision',
      id: visionId,
      onboardingStatus: OnboardingStatus.FULLY_ONBOARDED,
      isOptedInToRecurringLooks: true,
      currentLookBook: null,
    },
  },
} satisfies GetLookbookGalleryQuery;

export const defaultLookbookOptedOut = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    vision: {
      __typename: 'Vision',
      id: visionId,
      onboardingStatus: OnboardingStatus.FULLY_ONBOARDED,
      isOptedInToRecurringLooks: false,
      currentLookBook: {
        id: currentLookBookId,
        __typename: 'LookBook',
        looks: allMockLooks.slice(0, 3),
      },
    },
  },
} satisfies GetLookbookGalleryQuery;

export const noLookbook = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    vision: {
      __typename: 'Vision',
      id: visionId,
      onboardingStatus: OnboardingStatus.PENDING,
      isOptedInToRecurringLooks: true,
      currentLookBook: null,
    },
  },
} satisfies GetLookbookGalleryQuery;

export const defaultPreviousLooks = {
  client: {
    vision: {
      __typename: 'Vision',
      id: visionId,
      previousLooks: {
        __typename: 'LookConnection',
        pageInfo: {
          __typename: 'PageInfo',
          hasNextPage: true,
          endCursor: null,
        },
        nodes: allMockLooks.slice(3, 8),
      },
    },
  },
} satisfies GetLookbookPreviousLooksQuery;

export const noPreviousLooks = {
  client: {
    vision: {
      __typename: 'Vision',
      id: visionId,
      previousLooks: {
        __typename: 'LookConnection',
        pageInfo: {
          __typename: 'PageInfo',
          hasNextPage: false,
          endCursor: null,
        },
        nodes: [],
      },
    },
  },
} satisfies GetLookbookPreviousLooksQuery;

const generateLookResemblanceMock = (
  resemblesMeAnswer: boolean,
  lookId: string,
): UpdateLookResemblanceAnswerMutation => ({
  __typename: 'Mutation',
  visionLookResemblanceSubmit: {
    __typename: 'VisionLookResemblanceSubmitPayload',
    result: {
      __typename: 'VisionLookResemblanceSubmitSuccess',
      look: {
        __typename: 'Look',
        id: lookId,
        resemblesMeAnswer,
      },
    },
  },
});

const generateErrorMock = (
  message = 'Failed to update resemblance answer',
): UpdateLookResemblanceAnswerMutation => ({
  __typename: 'Mutation',
  visionLookResemblanceSubmit: {
    __typename: 'VisionLookResemblanceSubmitPayload',
    result: {
      __typename: 'VisionLookResemblanceSubmitError',
      message,
    },
  },
});

export const mockUpdateLookResemblanceHandler = ({
  delay,
  returnError = false,
}: {
  delay: number;
  returnError?: boolean;
}) =>
  graphql.mutation<
    UpdateLookResemblanceAnswerMutation,
    UpdateLookResemblanceAnswerMutationVariables
  >('updateLookResemblanceAnswer', (_req, res, ctx) => {
    const input = _req.variables.input as VisionLookResemblanceSubmitInput;
    const { resemblesMeAnswer, lookId } = input;

    const mockData = returnError
      ? generateErrorMock()
      : generateLookResemblanceMock(resemblesMeAnswer, lookId);

    return res(ctx.delay(delay), ctx.data(mockData));
  });

const generateVisionOptInOutSuccessMock = (
  optIn: boolean,
): UpdateVisionOptInOutAnswerMutation => ({
  __typename: 'Mutation',
  visionOptInUpdate: {
    __typename: 'VisionOptInUpdatePayload',
    result: {
      __typename: 'VisionOptInUpdateSuccess',
      vision: {
        __typename: 'Vision',
        id: visionId,
        isOptedInToRecurringLooks: optIn,
      },
    },
  },
});

const generateVisionOptInOutErrorMock = (
  message = 'Failed to update opt-in status',
): UpdateVisionOptInOutAnswerMutation => ({
  __typename: 'Mutation',
  visionOptInUpdate: {
    __typename: 'VisionOptInUpdatePayload',
    result: {
      __typename: 'VisionOptInUpdateError',
      message,
    },
  },
});

export const mockUpdateVisionOptInOutHandler = ({
  delay,
  returnError = false,
}: {
  delay: number;
  returnError?: boolean;
}) =>
  graphql.mutation<
    UpdateVisionOptInOutAnswerMutation,
    UpdateVisionOptInOutAnswerMutationVariables
  >('updateVisionOptInOutAnswer', (req, res, ctx) => {
    const input = req.variables.input as VisionOptInUpdateInput;
    const { optIn } = input;

    const mockData = returnError
      ? generateVisionOptInOutErrorMock()
      : generateVisionOptInOutSuccessMock(optIn);

    return res(ctx.delay(delay), ctx.data(mockData));
  });

export const mockLookbookHandler = (
  mockData: GetLookbookGalleryQuery,
  { delay }: { delay?: number | null } = {},
) =>
  graphql.query<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>(
    'getLookbookGallery',
    (_req, res, ctx) => {
      if (delay) {
        return res(ctx.delay(delay), ctx.data(mockData));
      }

      return res(ctx.data(mockData));
    },
  );

export const mockLookbookLoadingHandler = ({ delay }: { delay?: number }) =>
  graphql.query<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>(
    'getLookbookGallery',
    (_req, res, ctx) => {
      return res(ctx.delay(delay));
    },
  );

export const mockPreviousLooksHandler = (
  mockData: GetLookbookPreviousLooksQuery,
  { delay }: { delay?: number | null } = {},
) =>
  graphql.query<
    GetLookbookPreviousLooksQuery,
    GetLookbookPreviousLooksQueryVariables
  >('getLookbookPreviousLooks', (req, res, ctx) => {
    const response = mockData;

    if (delay) {
      return res(ctx.delay(delay), ctx.data(response));
    }

    return res(ctx.data(response));
  });

export const simplePaginationHandler = graphql.query(
  'getLookbookPreviousLooks',
  (req, res, ctx) => {
    const { page } = req.variables;
    const pageSize = 5;
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const pageData = allMockLooks.slice(startIndex, endIndex);

    return res(
      ctx.data({
        client: {
          __typename: 'Client',
          vision: {
            __typename: 'Vision',
            id: visionId,
            previousLooks: {
              __typename: 'LookConnection',
              nodes: pageData,
              pageInfo: {
                __typename: 'PageInfo',
                hasNextPage: endIndex < allMockLooks.length,
                endCursor: endIndex < allMockLooks.length ? `${page}` : null,
              },
            },
          },
        },
      }),
    );
  },
);

export const paginatePreviousLooksHandler = (pages: Look[][]) => {
  const pageData = new Map<number, Look[]>();

  return graphql.query('getLookbookPreviousLooks', (req, res, ctx) => {
    const { page } = req.variables;
    const currentPage = typeof page === 'number' ? page : 1;

    if (pageData.has(currentPage)) {
      return res(
        ctx.data({
          client: {
            __typename: 'Client',
            vision: {
              __typename: 'Vision',
              id: visionId,
              previousLooks: {
                __typename: 'LookConnection',
                nodes: pageData.get(currentPage) || [],
                pageInfo: {
                  __typename: 'PageInfo',
                  hasNextPage: currentPage < pages.length,
                  endCursor:
                    currentPage < pages.length ? `${currentPage}` : null,
                },
              },
            },
          },
        }),
      );
    }

    if (currentPage > pages.length) {
      return res(
        ctx.data({
          client: {
            __typename: 'Client',
            vision: {
              __typename: 'Vision',
              id: visionId,
              previousLooks: {
                __typename: 'LookConnection',
                nodes: [],
                pageInfo: {
                  __typename: 'PageInfo',
                  hasNextPage: false,
                  endCursor: null,
                },
              },
            },
          },
        }),
      );
    }

    const looks = pages[currentPage - 1] || [];

    pageData.set(currentPage, looks);

    const hasNextPage = currentPage < pages.length;
    const endCursor = hasNextPage ? `${currentPage}` : null;

    return res(
      ctx.data({
        client: {
          __typename: 'Client',
          vision: {
            __typename: 'Vision',
            id: visionId,
            previousLooks: {
              __typename: 'LookConnection',
              nodes: looks,
              pageInfo: {
                __typename: 'PageInfo',
                hasNextPage,
                endCursor,
              },
            },
          },
        },
      }),
    );
  });
};
